import styled from 'styled-components';
import { FlexColumn, FlexRow } from '@make-software/tg-mini-app-ui';

export const AccordionHeader = styled(FlexRow)<{ isOpen: boolean }>(({ theme, isOpen }) =>
  theme.withMedia({
    padding: '12px 20px',
    backgroundColor: '#3A3B46',
    borderRadius: isOpen ? '8px 8px 0 0' : '8px'
  })
);

export const ChevronWrapper = styled(FlexRow)<{ isOpen: boolean }>(({ theme, isOpen }) =>
  theme.withMedia({
    color: theme.colors.mainDark,
    transform: `rotate(${isOpen ? '0' : '180deg'})`,

    '& svg path': {
      stroke: theme.colors.mainWhite
    },

    '&:hover': {
      cursor: 'pointer'
    }
  })
);

export const AccordionBody = styled(FlexColumn)<{ isOpen: boolean }>(({ theme, isOpen }) =>
  theme.withMedia({
    gap: '12px',
    backgroundColor: '#30313B',
    borderTop: isOpen ? 'none' : undefined,
    borderRadius: '0 0 8px 8px',
    overflow: 'hidden',
    transition: 'max-height 0.8s ease'
  })
);

export const CriteriaItem = styled(FlexRow)<{ met: boolean }>(({ theme, met }) =>
  theme.withMedia({
    gap: '4px',
    color: met ? theme.colors.successCheck : theme.colors.mainGray,
    alignItems: 'center',
    fontSize: '13px',
    fontWeight: '500',
    fontFamily: theme.typography.fontFamily.sans
  })
);

export const ParticipateText = styled.div(({ theme }) =>
  theme.withMedia({
    fontSize: '14px',
    color: theme.colors.contentPrimary,
    fontWeight: 700,
    fontFamily: theme.typography.fontFamily.sans,
    lineHeight: '140%'
  })
);

export const OnchainBadge = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    fontSize: '11px',
    color: theme.colors.mainGreen,
    borderRadius: '4px',
    background: theme.colors.darkestBg
  })
);
